import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import InstallPrompt from "@/components/InstallPrompt";

import Landing from "@/pages/Landing";
import Lobby from "@/pages/Lobby";
import ChatRoom from "@/pages/ChatRoom";
import Profile from "@/pages/Profile";
import Invite from "@/pages/Invite";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AdminDownLow from "@/pages/AdminDownLow";
import AdminDashboard from "@/pages/AdminDashboard";
import DMs from "@/pages/DMs";

function RequireAuth({ children }) {
  const { user, initialized } = useAuth();
  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500">
        <div className="font-display tracking-wider text-sm animate-pulse">entering Xhat…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function RedirectIfAuth({ children }) {
  const { user, initialized } = useAuth();
  if (!initialized) return null;
  if (user) return <Navigate to="/lobby" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RedirectIfAuth><Landing /></RedirectIfAuth>} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/invite/:code" element={<Invite />} />
            <Route path="/lobby" element={<RequireAuth><Lobby /></RequireAuth>} />
            <Route path="/room/:id" element={<RequireAuth><ChatRoom /></RequireAuth>} />
            <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
            <Route path="/dms" element={<RequireAuth><DMs /></RequireAuth>} />
            <Route path="/admin/downlow" element={<RequireAuth><AdminDownLow /></RequireAuth>} />
            <Route path="/admin" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <InstallPrompt />
        <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#121215", border: "1px solid rgba(255,255,255,0.08)", color: "#fff" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
